<div class="filter">
  <network-services-shortcut-menu [productType]="productType()" />

  <section class="section">
    <div class="input__wrapper">
      <input
        type="search"
        [(ngModel)]="servicesSearch"
        value=""
        class="input input--search"
        name=""
        placeholder="{{ 'Form.Placeholder.SearchTerm' | translate }}"
      />
    </div>
  </section>

  <filter-by-status />

  <subscriptions-tags-filter [collectedTags]="collectedTags()" />

  <section class="section">
    <h3>{{ "Services.Filter.Endpoint" | translate }}</h3>
    <completer-location [locations]="collectedLocations()"></completer-location>
  </section>
</div>
